<template>
  <div v-if="!isLoading">
    <v-toolbar class="elevation-0" color="info" dark>
      <v-btn fab text class="ml-0" @click="$router.go(-1)">
        <v-icon color="white">arrow_back_ios</v-icon>
      </v-btn>

      <v-toolbar-title class="ml-0">
        <h1 class="headline">{{ batch.Store.businessName }}</h1>
        <h1 class="body-2">{{ batch.emailSubject }}</h1>
      </v-toolbar-title>
      <v-spacer />
      <v-btn color="pink" round @click="emailReport()">
        Email
      </v-btn>
    </v-toolbar>
    <div v-if="batch" v-html="batch.emailBody"></div>
  </div>
</template>

<script>
import batchService from "../service.js";

export default {
  name: "batch-view",
  data() {
    return {
      batch: null,
      isLoading: true
    };
  },
  created() {
    console.log("test");
    this.getById();
  },
  methods: {
    async emailReport() {
      const { value: text } = await this.$swal.fire({
        title: "Email Address",
        input: "email",
        showCancelButton: true
      });
      if (text) {
        let data = {
          toEmail: text,
          cspId: this.batch.Store.CSPID,
          subject: this.batch.emailSubject,
          body: this.batch.emailBody,
          businessName: this.batch.Store.businessName,
          mailType: "HTML"
        };
        // console.log('email', text, this.batch)
        return batchService
          .sendEmail(data)
          .then(result => {
            console.log("email result", result);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Email was send successfully."
              });
            // this.loadOrganization()
          })
          .catch(err => {
            this.$swal({
              title: `Batch Email`,
              text: `Can't send email`,
              type: "error"
            });
          });
      }
    },
    getById() {
      if (!this.$route.params || !this.$route.params.id) return this.$router.push("/batch");
      const id = this.$route.params.id;
      return batchService.getById(id).then(result => {
        this.batch = result.data;
        this.isLoading = false;
        console.log("test", result);
      });
    }
  }
};
</script>
